import React, { useEffect, useState } from "react"
import classes from './StudentTracking.module.css'
import AveragingScore from "./AveragingScore"
import AverageSubmissions from "./AverageSubmissions";
import StudentStatistic from './StudentStatistic'
import LineChart from "./LineChart";
import { submissionStatisticApi } from '../../../utils'
import { useDispatch, useSelector } from "react-redux";
import { throwApiError } from "../store/error-handling-actions";

const StudentTracking = ({ currentCourse, studyGroupId, userId, id }) => {
    const [statisticData, setStatisticData] = useState()

    const dispatch = useDispatch()
    const texts = useSelector(state => state.translate.texts);

    useEffect(() => {
        async function fetchData() {
            const data = { studyGroupId: studyGroupId, userId: userId }
            submissionStatisticApi.submissionStatisticsStudentPost({ submissionStatisticStudentInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.submissionsSingleStudentStatisticError, error: error, statusCode: response?.statusCode, message: "submissionsSingleStudentStatisticPost " + error.message, level: 2, component: "StudentTracking", line: 25 }))
                }
                else {
                    setStatisticData(response.body)
                }
            })
        }
        if (studyGroupId && userId && userId !== 0 && userId !== "0" && userId !== "undefined") {
            fetchData()
        }
    }, [studyGroupId, userId, texts]);


    return (
        <>
            {statisticData && <div className={classes.StudentTracking}>
                {window.innerWidth <= 1200 &&
                    <StudentStatistic statisticData={statisticData}></StudentStatistic>
                }
                {<div className={classes.TopCharts}>
                    {!(window.innerWidth <= 1200) && <StudentStatistic statisticData={statisticData}></StudentStatistic>}
                    <AveragingScore prvScoreAverage={statisticData?.userStatistic?.prevScoreAverage * 100} avergeScore={statisticData?.userStatistic?.scoreAverage * 100} avergeClass={statisticData?.scoreAverage * 100}></AveragingScore>
                    <AverageSubmissions avergeScore={(statisticData?.userStatistic?.submissionsCount / statisticData?.assessmentsCount) * 100} avergeClass={statisticData?.submissionsCountAverage * 100}></AverageSubmissions>
                </div>}
                <LineChart statisticData={statisticData} currentCourse={currentCourse} id={id}></LineChart>

            </div>}
        </>
    )
}
export default StudentTracking